module.exports = __webpack_public_path__ + "static/media/Privacy Policy.75062784.pdf";